import {AfterViewInit, Component, ViewChild} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { TableModel, table_data } from 'src/app/shared/models/data-table-example-items';

@Component({
    selector: 'app-advance',
    templateUrl: './advance.component.html',
    styleUrls: ['./advance.component.less'],
    standalone: false
})

export class AdvanceComponent implements AfterViewInit {

  displayedColumns: string[] = ['Details', 'ApprovalFor', 'RequestedBy', 'History','Action'];
  dataSource = new MatTableDataSource<TableModel>(table_data);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;


  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}




